import request from "@/utils/request";

const server = "";

/**
 * 协诊趋势统计（按天/按月）
 */
export function getCodiagTrend(params) {
  return request({
    url: server + "/business/cancer/statistics/codiagTrend",
    method: "post",
    params: params,
  });
}

/**
 * 科室协诊人数统计（年度）
 */
export function getCodiagByDept(params) {
  return request({
    url: server + "/business/cancer/statistics/codiagByDept",
    method: "post",
    params: params,
  });
}

/**
 * 高危患者年龄/性别分布
 */
export function getPatientDistribution() {
  return request({
    url: server + "/business/cancer/statistics/patientDistribution",
    method: "post",
  });
}

/**
 * 导出统计分析列表（科室/年龄/性别/管理标签）
 */
export function exportDistributionExcel(params) {
  return request({
    url: server + "/business/cancer/statistics/exportDistribution",
    method: "post",
    params: params,
    responseType: 'blob',
  });
}

/**
 * 导出月度协诊列表
 */
export function exportCodiagExcel(params) {
  return request({
    url: server + "/business/cancer/statistics/exportCodiag",
    method: "post",
    params: params,
    responseType: 'blob',
  });
}

/**
 * 导出协诊列表（完整版：含检查、诊断、备注）
 */
export function exportCodiagDetailExcel(params) {
  return request({
    url: server + "/business/cancer/statistics/exportCodiagDetail",
    method: "post",
    params: params,
    responseType: 'blob',
  });
}
